import { Component,  Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'fake-dropdown', // for Rob
    template: `
<div>{{ title }} </div>
<icon [matIcon]="'arrow_drop_down'"></icon>
`,
    styles: [`
:host { border: 1px solid #ddd; border-radius: 6px; display: flex; cursor: pointer; padding: 6px 3px 6px 8px; align-items: center; }
icon { margin-left: 2px; }
`],
    standalone: true,
    imports: [IconComponent],
})
export class FakeDropdownComponent {
  @Input() title: string = ''
}

